<template>
  <div>
    <b-card class="card-custom" header-tag="header" footer-tag="footer">
      <template v-slot:header>
        <div class="card-title">
          <h3 class="card-label">
            {{ $t("STOCK_EXPENSE_DOC") }}
            <i class="mr-2"></i>
            <small class="">{{ $t("LIST") }}</small>
          </h3>
        </div>
        <div class="card-toolbar"></div>
      </template>
      <v-card v-show="!isPageLoading">
        <SearchTools
          :searchQuery.sync="searchQuery"
          @do-search="doSearch"
          @do-clear="doClear"
        >
          <template v-slot:prepend>
            <b-col :sm="6">
              <FormDatepicker
                class="pt-10"
                v-model="filters.dates"
                :type="'text'"
                clearable
                :i18n="{
                  label: 'DATE'
                }"
              ></FormDatepicker>
            </b-col>
            <b-col :sm="6">
              <v-autocomplete
                :items="stores"
                :label="$t('STORE')"
                item-text="name"
                item-value="id"
                clearable
                v-model="filters.storeId"
                @click:clear="clearFilter('storeId')"
              ></v-autocomplete>
            </b-col>
          </template>
        </SearchTools>
        <v-data-table
          :item-class="itemOrderRow"
          :headers="tableHeaders"
          :items-per-page="totalItems"
          :options.sync="options"
          :items="items"
          sort-by="order"
          sort-desc="true"
          :loading="isLoadingStock"
          loading-text="Loading... Please wait"
          class="elevation-1"
        >
          <template v-slot:item.name="{ item }">
            {{ item.name }}
            <small>({{ item.unit }})</small>
          </template>
          <template v-slot:item.order="{ item }">
            {{ item.order ? "Order" : "Ok" }}
          </template>

          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              Your search for "{{ searchQuery }}" found no results.
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <v-skeleton-loader
        v-if="isPageLoading"
        :loading="isPageLoading"
        type="table"
      ></v-skeleton-loader>
      <v-overlay :value="!firstLoader && isLoadingSharedStore">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <template v-slot:footer>
        <div class="text-right">
          <v-progress-circular
            v-show="isXmlLoading"
            indeterminate
            color="green"
          ></v-progress-circular>
          <v-btn
            v-show="!isXmlLoading"
            color="btn-light-success"
            class="btn btn-light-success font-weight-bolder mr-2"
            @click="getXML()"
          >
            <i class="far fa-file-excel"></i>
            {{ $t("EXPORT") }}
          </v-btn>
        </div>
      </template>
    </b-card>
  </div>
</template>
<style scoped>
tr.previewTr th {
  font-size: 18px !important;
}
</style>
<script>
//General
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import { mapGetters } from "vuex";
import SearchTools from "@/core/components/table/SearchTools.vue";

import { FETCH_STORES_BASIC } from "@/core/services/store/shared_store.module";
import {
  EXPORT_EXPENSES_XLS,
  FETCH_EXPENSES
} from "@/modules/stock/store/stock.module";

import { permissionMixin } from "@/core/mixins/permissionMixin.js";

import _ from "lodash";
import moment from "moment";
import FormDatepicker from "@/view/content/forms/components/FormDatepicker.vue";

export default {
  name: "StockActionItemList",
  mixins: [permissionMixin],
  data() {
    return {
      firstLoader: true,
      isPageLoading: true,
      isXmlmzLoading: true,
      items: [],
      stores: [],
      dates: [],
      totalItems: 100,
      allItemsTotalPriceSum: 0,
      searchQuery: "",
      filters: {
        storeId: null,
        dates: []
      },
      options: {
        descending: true,
        page: 1,
        itemsPerPage: -1,
        totalItems: 100
      },
      rowsPerPageItems: [-1, 10, 50],
      columns: {},
      cancelSource: null,
      headers: [
        {
          text: this.$t("CODE_MZ"),
          value: "code",
          sortable: true
        },
        {
          text: this.$t("NAME_MZ"),
          align: "start",
          filterable: true,
          value: "name",
          sortable: true
        },
        {
          text: this.$t("STORE_UNIT"),
          value: "unit",
          sortable: true
        },
        {
          text: this.$t("STORE_EXPENSES_AVAILABLE"),
          value: "available",
          sortable: true
        },

        {
          text: this.$t("STORE_EXPENSES_QUANTITY"),
          align: "start",
          filterable: true,
          value: "expense",
          sortable: true
        },
        {
          text: this.$t("STORE_EXPENSES_DAY"),
          value: "perDay",
          sortable: true
        },
        {
          text: this.$t("STORE_EXPENSES_DAYS_LEFT"),
          value: "remainingDays",
          sortable: true,
          order: "desc"
        },
        {
          text: this.$t("STORE_EXPENSES_WEEKS"),
          value: "weeks",
          sortable: true
        },
        {
          text: this.$t("STORE_EXPENSES_ORDER"),
          value: "order",
          sortable: true
        }
      ]
    };
  },
  components: {
    FormDatepicker,
    SearchTools
  },
  watch: {
    storesParams(value) {
      let vm = this;
    },
    suppliersParams(value) {
      let vm = this;
    }
  },
  mounted() {
    let vm = this;
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Stock Actions", route: { name: "stock-actions-list" } },
      { title: "Stock Actions List" }
    ]);
    vm.getStores();
    vm.getDataFromApi();
  },
  computed: {
    ...mapGetters(["isLoadingStock", "isLoadingSharedStore"]),
    params() {
      return {
        ...this.options,
        query: this.searchQuery,
        storeId: this.filters.storeId,
        dates: this.filters.dates
      };
    },
    storesParams() {
      let storesParams = {};
      return storesParams;
    },
    tableHeaders() {
      let vm = this;

      return vm.headers;
    }
  },
  methods: {
    clearFilter(key) {
      let vm = this;
      vm.$nextTick(function() {
        this.$set(vm.filters, key, null);
      });
    },
    cancelRequest() {
      //Axios cancelSource to stop current search if new value is entered
      if (this.cancelSource) {
        this.cancelSource.cancel("Start new search, stop active search");
      }
    },
    doSearch() {
      let vm = this;
      if (vm.options.page == 1) {
        vm.getDataFromApi();
      } else {
        vm.options.page = 1;
      }
    },
    doClear() {
      let vm = this;
      vm.searchQuery = "";
      vm.filters.dates = [];
      if (vm.options.page == 1) {
        vm.getDataFromApi();
      } else {
        vm.options.page = 1;
      }
    },
    getXML() {
      let vm = this;
      vm.isLoadingStoreDailyTasks = true;
      let params = this.params;
      let apiParams = vm.transformUrlParams(params);
      this.$store
        .dispatch(EXPORT_EXPENSES_XLS, apiParams)
        .then(data => {
          vm.firstLoader = false;
          vm.$nextTick(function() {
            let blob = new Blob([data], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "razhod-" + vm.filters.dates;
            link.click();
            link.remove();
            if (vm.isPageLoading == true || vm.isXmlLoading == true) {
              vm.isPageLoading = false;
              vm.isXmlLoading = false;
            }
          });
        })
        .catch(response => {
          console.log(response);
          if (response.status === 404) {
            vm.$notify({
              group: "notify",
              type: "error",
              text: "Not Found"
            });
          }
        });
    },
    getDataFromApi() {
      let vm = this;
      let params = this.params;
      let apiParams = vm.transformUrlParams(params);
      // console.log(apiParams);
      vm.$store
        .dispatch(FETCH_EXPENSES, apiParams)
        .then(data => {
          vm.firstLoader = false;
          vm.$nextTick(function() {
            vm.items = data.data;
            if (vm.isPageLoading == true) {
              vm.isPageLoading = false;
            }
          });
        })
        .catch(response => {
          console.log(response);
          if (response.status === 404) {
            vm.$notify({
              group: "notify",
              type: "error",
              text: "Nout Found"
            });
            this.$router.push({ name: "stock-actions-list" });
          }
        });
    },
    getStores() {
      let vm = this;
      let params = this.storesParams;
      let apiParams = vm.transformUrlParams(params);
      this.$store
        .dispatch(FETCH_STORES_BASIC, apiParams)
        .then(data => {
          this.$set(vm, "stores", data.data);
          vm.filters.storeId = data.data[0].id;
        })
        .catch(response => {
          console.log(response);
        });
    },
    transformUrlParams(params) {
      let apiParams =
        "?" +
        Object.keys(params)
          .map(key => key + "=" + params[key])
          .join("&");
      return apiParams;
    },
    itemOrderRow(item) {
      return item.order ? "text-danger" : "";
    }
  }
};
</script>
